import React from "react";
import classnames from "classnames";
import isEmpty from "lodash/isEmpty";

const IconCollection = props => {
    let { icon } = props;
    let collections = null;
    let collectionsKey = `${icon.id}.collections`;
    if (!isEmpty(icon.collections)) {
        collections = icon.collections.map(collection => {
            let collection_title =
                "View the " + collection.name + " collection";
            return (
                <div key={collectionsKey + collection.id}>
                    In the&nbsp;
                    <a href={collection.permalink} title={collection_title}>
                        {collection.name} Collection
                    </a>
                </div>
            );
        });
    } else if (!isEmpty(props.collection)) {
        let collection_title =
            "View the " + props.collection.name + " collection";
        collections = (
            <div key={collectionsKey + props.collection.id}>
                In the
                <a href={props.collection.permalink} title={collection_title}>
                    {props.collection.name} Collection
                </a>
            </div>
        );
    }

    return <div className="hero-collections">{collections}</div>;
};
export default IconCollection;
